/* MH cart reconciliation: add-ons -> real Shopify discount -> gift -> render.
 * The code-only Bundle Bear transport matches the installed runtime on
 * 19 October 2026. This endpoint is not a published SDK: confirm the contract
 * with Conversion Bear before publication and when upgrading their runtime.
 */
(function () {
  'use strict';
  var baseFetch = window.fetch.bind(window);
  var active = 0, revision = 0, running = null, timer = null;
  var wantOpen = false, adapters = {}, bundleCode = null, lastError = null;
  var checkout = false;
  var codeCache = null, renderedCart = null, settledRevision = -1;
  var pendingCart = null, pendingSections = null, settledCart = null;
  var writeTail = Promise.resolve();
  // The Bear code survives page loads, so an unchanged cart costs one cart.js read
  // instead of a Bear request + cart/update.js on every page. Shopify still has to
  // report the code as applicable before the cached code is trusted.
  var CACHE_KEY = 'mhBundleCodeCache', CACHE_TTL = 15 * 60 * 1000;
  try { codeCache = JSON.parse(sessionStorage.getItem(CACHE_KEY)) || null; } catch (_) { codeCache = null; }
  if (codeCache && codeCache.code) bundleCode = codeCache.code;
  // Every Bear answer per cart input, so going back to an earlier cart (+1 then -1)
  // needs no new Bear request. Shopify still validates the code on every write.
  var MEMO_KEY = 'mhBundleCodeMemo', codeMemo = {};
  try { codeMemo = JSON.parse(sessionStorage.getItem(MEMO_KEY)) || {}; } catch (_) { codeMemo = {}; }
  function memoGet(shop, input) {
    var hit = codeMemo[shop + '|' + input];
    return hit && Date.now() - hit.at < CACHE_TTL ? hit : null;
  }
  function memoSet(shop, input, code) {
    codeMemo[shop + '|' + input] = { code: code, at: Date.now() };
    var keys = Object.keys(codeMemo);
    if (keys.length > 30) keys.sort(function (a, b) { return codeMemo[a].at - codeMemo[b].at; }).slice(0, keys.length - 30).forEach(function (key) { delete codeMemo[key]; });
    try { sessionStorage.setItem(MEMO_KEY, JSON.stringify(codeMemo)); } catch (_) {}
  }
  function saveCache() {
    try {
      if (codeCache) sessionStorage.setItem(CACHE_KEY, JSON.stringify(codeCache));
      else sessionStorage.removeItem(CACHE_KEY);
    } catch (_) {}
  }
  // Ask Shopify to render the drawer in the same response as a cart change, so the
  // drawer can be redrawn without a separate section request.
  function withSections(body) {
    if (typeof body !== 'string') return body;
    try {
      var data = JSON.parse(body);
      if (!data || typeof data !== 'object' || Array.isArray(data) || data.sections) return body;
      data.sections = ['cart-drawer']; data.sections_url = root('');
      return JSON.stringify(data);
    } catch (_) { return body; }
  }
  // Liquid renders the drawer with this signature; equal means the page HTML is current.
  function serverSignature(cart) {
    return [cart.item_count, cart.total_price, cart.total_discount || 0, cart.items.length].join('-');
  }
  function write(work) {
    var next = writeTail.then(work);
    writeTail = next.catch(function () {});
    return next;
  }
  var discounting = false, renderedLines = null;
  function linesKey(cart) {
    return (cart.items || []).map(function (item) { return item.key + ':' + item.quantity; }).join('|');
  }
  function sectionFor(cart) {
    if (cart.sections) return Promise.resolve(cart);
    return baseFetch(root('') + '?section_id=cart-drawer', { cache: 'no-store' })
      .then(function (res) { return res.ok ? res.text() : null; })
      .catch(function () { return null; })
      .then(function (html) { return html ? Object.assign({}, cart, { sections: { 'cart-drawer': html } }) : cart; });
  }
  var errorText = 'Your cart could not be updated. Please try again.';
  function pause(ms) { return new Promise(function (resolve) { window.setTimeout(resolve, ms); }); }
  function root(path) { return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + path; }
  function readCart() {
    return baseFetch(root('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json);
  }
  function json(res) {
    return res.json().then(function (data) {
      if (!res.ok) throw new Error(data.description || data.message || 'Cart request failed');
      return data;
    });
  }
  function post(path, data) {
    return write(async function () {
      var version = revision;
      pendingCart = null; pendingSections = null;
      var payload = Object.assign({}, data);
      // Insurance preparation is followed by discount calculation, so rendering
      // that intermediate add would waste server work. Gift adds are final candidates.
      if (path !== 'cart/add.js' || (data.properties && data.properties._mh_gift === 'mystery-gift')) {
        payload.sections = ['cart-drawer']; payload.sections_url = root('');
      }
      var result = await baseFetch(root(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) }).then(json);
      rememberResponse(result, version);
      return result;
    });
  }
  function fullCart(value) { return value && Array.isArray(value.items) && typeof value.total_price === 'number' && typeof value.item_count === 'number'; }
  function rememberResponse(value, version) {
    if (active || version !== revision) return;
    if (fullCart(value)) pendingCart = { cart: value, revision: revision };
    if (value && value.sections) pendingSections = { sections: value.sections, revision: revision };
  }
  async function nextCart() {
    var version = revision;
    var cart = pendingCart && pendingCart.revision === version ? pendingCart.cart : null;
    pendingCart = null;
    if (!cart) cart = await readCart();
    if (!active && revision === version && pendingSections && pendingSections.revision === version) cart.sections = pendingSections.sections;
    return cart;
  }
  function feedback(error, busy) {
    var drawer = document.querySelector('mh-cart-drawer');
    if (!drawer) return;
    drawer.classList.toggle('is-loading', !!busy);
    drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
    // The overlay fades in through a CSS animation: after a short delay for plain cart
    // updates, at once while a bundle discount is being calculated.
    drawer.classList.toggle('is-discounting', !!busy && discounting);
    var status = drawer.querySelector('[data-mh-cd-sync-status]');
    if (status) status.hidden = !busy;
    // Plain updates only block clicks (.is-loading → pointer-events: none) so nothing greys
    // out for a split second; controls are really disabled only behind the bundle loader.
    var lock = !!busy && discounting;
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-mh-cd-qty] button, [data-mh-cd-qty] input, [data-mh-cd-remove], [data-mh-cd-addon-toggle], [data-mh-cd-upsell-add]'), function (control) {
      if (lock && !control.disabled) { control.setAttribute('data-mh-sync-disabled', ''); control.disabled = true; }
      else if (!lock && control.hasAttribute('data-mh-sync-disabled')) { control.disabled = false; control.removeAttribute('data-mh-sync-disabled'); }
    });
    var button = drawer.querySelector('#MHCartDrawer-Checkout');
    if (button) {
      button.setAttribute('aria-disabled', busy ? 'true' : 'false');
      if (busy && discounting && button.__mhCheckoutLabel == null) button.__mhCheckoutLabel = button.textContent;
      if (busy && discounting) button.textContent = 'Updating cart…';
      else if (button.__mhCheckoutLabel != null) { button.textContent = button.__mhCheckoutLabel; delete button.__mhCheckoutLabel; }
    }
    var message = drawer.querySelector('[data-mh-cd-sync-error]');
    if (message) { message.hidden = !error; message.textContent = error ? errorText : ''; }
  }
  function mutationUrl(value, method) {
    if (String(method || 'GET').toUpperCase() === 'GET') return false;
    try {
      var url = new URL(value, window.location.href);
      return url.origin === window.location.origin && /\/cart\/(add|change|update|clear)(\.js|\.json)?\/?$/.test(url.pathname);
    } catch (_) { return false; }
  }
  function begin() { active++; revision++; pendingCart = null; pendingSections = null; feedback(null, true); }
  function end(cart, version) {
    active--; var fresh = version === revision; revision++;
    if (fresh) rememberResponse(cart, revision);
    // Start the slow Bear request now, in parallel with other apps' writes and the
    // drawer render; discount() picks up the same in-flight request.
    if (fullCart(cart)) prefetch(cart);
    else if (cart) readCart().then(prefetch).catch(function () {});
    schedule(false);
  }
  // Observe all successful and failed cart writes, including other apps and
  // drawer-owned writes. Coordinator writes use baseFetch and cannot recurse.
  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : resource && (resource.url || String(resource));
    var tracked = mutationUrl(url, (init && init.method) || (resource && resource.method));
    if (tracked) begin();
    if (tracked && init && /\/cart\/(add|change|update)(\.js)?\/?(\?|$)/.test(url)) init = Object.assign({}, init, { body: withSections(init.body) });
    var result = tracked ? write(function () { return baseFetch(resource, init); }) : baseFetch(resource, init);
    return result.then(async function (res) {
      if (tracked) {
        var version = revision, cart = null;
        // Consume a clone, never the app's response body. change/update already
        // return a full cart, making an immediate cart.js GET redundant.
        if (res.ok && typeof res.clone === 'function') {
          try { cart = await res.clone().json(); } catch (_) {}
        }
        end(cart, version);
      }
      return res;
    }, function (error) { if (tracked) end(); throw error; });
  };
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) { this.__mhSyncWrite = mutationUrl(url, method); return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (!this.__mhSyncWrite) return send.apply(this, arguments);
      var xhr = this, args = arguments;
      begin();
      write(function () {
        return new Promise(function (resolve) {
          // It may have been aborted while waiting behind another cart write.
          if (xhr.readyState !== 1) { end(); resolve(); return; }
          function done() {
            xhr.removeEventListener('loadend', done);
            var cart = null;
            if (xhr.status >= 200 && xhr.status < 300) {
              try { cart = xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText); } catch (_) {}
            }
            end(cart, revision); resolve();
          }
          xhr.addEventListener('loadend', done);
          try { send.apply(xhr, args); }
          catch (error) { done(); console.error('[mh-cart-sync:xhr]', error); }
        });
      });
    };
  }

  async function idle() {
    var deadline = Date.now() + 15000;
    while (active) { if (Date.now() > deadline) throw new Error('Cart write timed out'); await pause(40); }
  }
  function productList(cart) {
    var grouped = {};
    cart.items.forEach(function (item) {
      var row = grouped[item.product_id];
      var variant = { id: item.id || item.variant_id, price: Number(item.price) / 100, quantity: Number(item.quantity) };
      if (!row) grouped[item.product_id] = { id: item.product_id, price: variant.price, quantity: variant.quantity, variants: [variant] };
      else {
        row.price = (row.price * row.quantity + variant.price * variant.quantity) / (row.quantity + variant.quantity);
        row.quantity += variant.quantity;
        row.variants.push(variant);
      }
    });
    return Object.keys(grouped).map(function (key) { return grouped[key]; });
  }
  function isGift(item) { return item.properties && item.properties._mh_gift === 'mystery-gift'; }
  function addonIds() {
    var ids = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-mh-cd-addon][data-product-id]'), function (row) { ids[row.getAttribute('data-product-id')] = true; });
    return ids;
  }
  // Drawer add-ons (shipping insurance, free e-book) and the mystery gift are not offer
  // products. Leaving them out keeps the Bear input stable when they come and go, so
  // adding insurance or the gift never costs a second ~3 s Bear request.
  function isExtra(item, addons) {
    return isGift(item) || !(item.price > 0) || addons[String(item.product_id)] || !!(item.properties && item.properties._mh_pdp_addon);
  }
  function bundleData(cart, excludeGift) {
    var converter = window.conversionBearAutoCurrencyConverter;
    var addons = addonIds();
    return { productList: productList({ items: cart.items.filter(function (item) { return !isExtra(item, addons); }) }),
      // Bear makes the code in the shop's currency: without its converter script (e.g. .com) the
      // rate must come from Shopify, else a code for a EUR cart in a GBP shop is 1.2x too big.
      currencyRate: (converter && converter.shopifyPaymentsRateOverride) || parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1, shopifyDiscount: window.bundleShopifyDiscount };
  }
  function paidPrices(cart) {
    return JSON.stringify(cart.items.filter(function (item) { return !isGift(item); }).map(function (item) {
      return JSON.stringify([item.product_id, item.variant_id || item.id, item.quantity, item.price, item.final_line_price, item.properties]);
    }).sort());
  }
  function codeStatus(cart) {
    return JSON.stringify((cart.discount_codes || []).map(function (entry) { return [entry.code, !!entry.applicable]; }).sort());
  }
  // Every Bundle Bear offer in this shop needs at least 2 paid units or a 100 cart goal in
  // the shop's currency (quantity offers start at "buy 2"). Below both, the code
  // is always null, so the ~2 s Bear request is skipped. Update these two values
  // when an offer with a lower minimum is added in Bundle Bear.
  var BEAR_MIN_UNITS = 2, BEAR_MIN_GOAL_CENTS = 10000;
  // Only products carrying one of the drawer's bundle tags (Cart drawer section → "Bundle
  // Bear tags") can get a Bundle Bear discount. Carts without them never wait for Bear.
  // Tags come from the drawer markup (cart lines + current product), else product.js.
  var TAGS_KEY = 'mhProductTags', productTags = {};
  try { productTags = JSON.parse(sessionStorage.getItem(TAGS_KEY)) || {}; } catch (_) { productTags = {}; }
  function saveTags() { try { sessionStorage.setItem(TAGS_KEY, JSON.stringify(productTags)); } catch (_) {} }
  function bundleTags(scope) {
    var el = (scope || document).querySelector('[data-mh-cd-bundle-tags]');
    if (!el) return null;
    var list = el.getAttribute('data-mh-cd-bundle-tags').split(',').map(function (tag) { return tag.trim().toLowerCase(); }).filter(Boolean);
    // Empty setting = no tag rule: Bear's own offer lookup decides per product.
    return list;
  }
  function readTagMap(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('script[data-mh-cd-product-tags]'), function (node) {
      try { JSON.parse(node.textContent).forEach(function (pair) { productTags[pair[0]] = pair[1]; }); } catch (_) {}
    });
    saveTags();
  }
  function readTagsFromHtml(html) {
    if (typeof html !== 'string' || html.indexOf('data-mh-cd-product-tags') < 0) return;
    readTagMap(new DOMParser().parseFromString(html, 'text/html'));
  }
  readTagMap(document);
  function ensureTags(cart) {
    // Unknown products already count as bundle products; a lookup only helps when that
    // assumption is what makes a Bear request necessary.
    if (noOfferPossible(cart)) return Promise.resolve();
    var addons = addonIds();
    var missing = cart.items.filter(function (item) {
      return !isGift(item) && item.price > 0 && !addons[String(item.product_id)] && !(item.properties && item.properties._mh_pdp_addon);
    }).map(function (item) { return item.handle; }).filter(function (handle, i, all) {
      return handle && !productTags[handle] && all.indexOf(handle) === i;
    });
    var tagList = bundleTags();
    if (!missing.length || (tagList && !tagList.length)) return Promise.race([ensureOffers(cart, bundleTags()), pause(1500)]);
    var lookups = Promise.all(missing.map(function (handle) {
      return baseFetch(root('products/' + encodeURIComponent(handle) + '.js'), { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) { if (product && Array.isArray(product.tags)) productTags[handle] = product.tags; })
        .catch(function () {});
    })).then(saveTags).then(function () { return ensureOffers(cart, bundleTags()); });
    // Never let a slow lookup hold the cart: unknown products count as bundle products.
    return Promise.race([lookups, pause(1500)]);
  }
  // Products without a bundle tag can still have a Bundle Bear offer (e.g. a bundle set
  // up for one specific product). Ask Bear's offer lookup once per product and remember it.
  var OFFERS_KEY = 'mhBearOffers', bearOffers = {};
  try { bearOffers = JSON.parse(sessionStorage.getItem(OFFERS_KEY)) || {}; } catch (_) { bearOffers = {}; }
  function tagMatch(item, tags) {
    var known = productTags[item.handle];
    return !!known && known.some(function (tag) { return tags.indexOf(String(tag).trim().toLowerCase()) >= 0; });
  }
  function isBundleItem(item, tags) {
    if (!tags) return true;
    if (tagMatch(item, tags)) return true;
    var offer = bearOffers[String(item.product_id)];
    if (offer === true) return true;
    if (offer === false && (productTags[item.handle] || !tags.length)) return false;
    // Unknown product: count it, so a discount is never skipped by mistake.
    return true;
  }
  function ensureOffers(cart, tags) {
    var shop = bearShop();
    if (!shop || !tags) return Promise.resolve();
    var addons = addonIds();
    var ids = cart.items.filter(function (item) {
      return !isGift(item) && item.price > 0 && !addons[String(item.product_id)] && !(item.properties && item.properties._mh_pdp_addon) &&
        !tagMatch(item, tags) && bearOffers[String(item.product_id)] === undefined;
    }).map(function (item) { return String(item.product_id); }).filter(function (id, i, all) { return all.indexOf(id) === i; });
    if (!ids.length) return Promise.resolve();
    return Promise.all(ids.map(function (id) {
      return baseFetch('https://bundle.conversionbear.com/widget?shop=' + encodeURIComponent(shop) + '&product_id=' + id + '&currency=' + encodeURIComponent((window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'))
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) { if (data) bearOffers[id] = !!data.offer; })
        .catch(function () {});
    })).then(function () { try { sessionStorage.setItem(OFFERS_KEY, JSON.stringify(bearOffers)); } catch (_) {} });
  }
  function noOfferPossible(cart) {
    // Bear's cart goal is set in the shop's own currency (100 € / £100 / 100 kr). Shopify's rate
    // turns it into the currency the customer pays in; 5% margin for Bear's rounding.
    var active = window.Shopify && Shopify.currency;
    var rate = active && active.active === cart.currency ? parseFloat(active.rate) : NaN;
    var goal = rate > 0 ? BEAR_MIN_GOAL_CENTS * rate * 0.95 : (!cart.currency || cart.currency === 'EUR' ? BEAR_MIN_GOAL_CENTS : 0);
    if (!goal) return false;
    var addons = addonIds();
    var tags = bundleTags();
    var units = 0, subtotal = 0;
    cart.items.forEach(function (item) {
      if (isGift(item) || !(item.price > 0)) return;
      // Drawer add-ons (shipping insurance) are not products a bundle offer can target.
      if (addons[String(item.product_id)] || (item.properties && item.properties._mh_pdp_addon)) return;
      if (!isBundleItem(item, tags)) return;
      subtotal += item.price * item.quantity;
      units += item.quantity;
    });
    return units < BEAR_MIN_UNITS && subtotal < goal;
  }
  // True when the discount step will have to wait for the Bundle Bear server.
  function bearWaitAhead(cart) {
    if (!cart.items.length || noOfferPossible(cart)) return false;
    var shop = bearShop();
    if (!shop || isSubscription(cart)) return false;
    var serialized = JSON.stringify(bundleData(cart, false));
    var fresh = codeCache && codeCache.shop === shop && Date.now() - codeCache.at < CACHE_TTL;
    if (fresh && (codeCache.input === serialized || codeCache.baseInput === JSON.stringify(bundleData(cart, true)))) return false;
    var memo = memoGet(shop, serialized);
    if (!memo) return true;
    // Bear may already have answered (its request starts at the click), but writing a new
    // code to the cart is another ~2 s round trip that changes the prices: keep the loader.
    var current = (cart.discount_codes || []).map(function (entry) { return entry.code; });
    return memo.code ? current.indexOf(memo.code) < 0 : current.some(function (value) { return /^BUNDLE-/i.test(value); });
  }
  function bearShop() {
    var script = Array.prototype.find.call(document.scripts, function (node) {
      return node.src && node.src.indexOf('https://bundle.conversionbear.com/script?') === 0;
    });
    // ScriptTag apps can be lazy-loaded until the first user interaction.
    // Shopify.shop is already provided by the theme before deferred assets.
    var shop = (script && new URL(script.src).searchParams.get('shop')) || (window.Shopify && window.Shopify.shop);
    return shop && /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop) ? shop : null;
  }
  function isSubscription(cart) {
    return cart.items.some(function (item) { return item.properties && Object.prototype.hasOwnProperty.call(item.properties, 'frequency_num'); });
  }
  var inflight = {};
  // One Bear request per cart input, shared by prefetch() and discount().
  function requestCode(shop, serialized) {
    var memo = memoGet(shop, serialized);
    if (memo) return Promise.resolve(memo.code);
    var key = shop + '|' + serialized;
    if (inflight[key]) return inflight[key];
    var data = JSON.parse(serialized);
    // object-hash (the installed app) hashes a string as this UTF-8 prefix + value.
    var bytes = new TextEncoder().encode('string:' + serialized.length + ':' + serialized);
    var request = window.crypto.subtle.digest('SHA-1', bytes).then(function (digest) {
      data.hash = Array.prototype.map.call(new Uint8Array(digest), function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
      return baseFetch('https://bundle.conversionbear.com/widget/discount_code?shop=' + encodeURIComponent(shop), {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data), signal: controller.signal
      }).then(json).finally(function () { window.clearTimeout(timeout); });
    }).then(function (response) {
      if (!response || !Object.prototype.hasOwnProperty.call(response, 'code') || (response.code !== null && typeof response.code !== 'string')) throw new Error('Invalid Bundle Bear code response');
      memoSet(shop, serialized, response.code);
      return response.code;
    });
    inflight[key] = request;
    function forget() { delete inflight[key]; }
    request.then(forget, forget);
    return request;
  }
  function prefetch(cart) {
    try {
      if (!fullCart(cart) || !cart.items.length || isSubscription(cart) || noOfferPossible(cart)) return;
      var shop = bearShop();
      if (!shop) return;
      // Gift-only changes reuse the previous code in discount(); no request needed.
      if (codeCache && codeCache.shop === shop && codeCache.baseInput === JSON.stringify(bundleData(cart, true))) return;
      requestCode(shop, JSON.stringify(bundleData(cart, false))).catch(function () {});
    } catch (_) {}
  }
  async function discount(cart) {
    if (!cart.items.length) return cart;
    var addons = addonIds();
    // Only extras left (e.g. insurance before it is cleared): nothing for Bear to price.
    if (!cart.items.some(function (item) { return !isExtra(item, addons); })) return cart;
    // applyDiscount() can itself navigate to /checkout on an HTTP failure.
    // Its public goToCheckout() is also navigation-only. Request the code using
    // the installed app's exact wire contract so a failure cannot skip our gate.
    var shop = bearShop();
    if (!shop) throw new Error('Bundle Bear shop configuration is missing');
    if (isSubscription(cart)) throw new Error('Subscription cart needs a supported Bundle Bear integration');
    var data = bundleData(cart, false);
    var serialized = JSON.stringify(data);
    var baseInput = JSON.stringify(bundleData(cart, true));
    var validCache = codeCache && codeCache.shop === shop && Date.now() - codeCache.at < CACHE_TTL;
    var cached = validCache && codeCache.input === serialized;
    // A free mystery-gift-only change needs no second Bear code when Shopify
    // confirms identical merchandise prices AND identical native code status.
    // Any changed price, merchandise, code, converter or app configuration falls
    // back to a full fresh calculation. A charged gift never takes this path.
    if (!cached && validCache && codeCache.baseInput === baseInput && codeCache.prices === paidPrices(cart) &&
        codeCache.codes === codeStatus(cart) && cart.items.filter(isGift).every(function (item) { return item.final_line_price === 0; })) {
      codeCache.input = serialized;
      saveCache();
      return cart;
    }
    // "No offer possible" is decided locally and is never stored: once a product turns out to
    // be a bundle product, the same cart must still get a real answer from Bear.
    var skipped = !cached && noOfferPossible(cart);
    var code = cached ? codeCache.code : skipped ? null : await requestCode(shop, serialized);
    if (!cached && !skipped) codeCache = { input: serialized, baseInput: baseInput, shop: shop, code: code, at: Date.now() };
    // Keep unrelated customer codes; discard only a previous app-generated code.
    var codes = (cart.discount_codes || []).map(function (entry) { return entry.code; }).filter(function (value) {
      return value && value !== bundleCode && !/^BUNDLE-/i.test(value);
    });
    if (code && codes.indexOf(code) < 0) codes.push(code);
    bundleCode = code;
    // Reopening the same cart and its checkout click need no new discount write.
    // Never trust a cached code unless Shopify still marks it applicable.
    var current = cart.discount_codes || [];
    if (current.length === codes.length && current.every(function (entry) { return codes.indexOf(entry.code) >= 0; }) &&
        (!code || current.some(function (entry) { return entry.code === code && entry.applicable; }))) {
      if (codeCache && !skipped) {
        codeCache.prices = paidPrices(cart);
        codeCache.codes = codeStatus(cart);
      }
      saveCache();
      return cart;
    }
    // Shopify returns the section with the same accepted discount response,
    // avoiding a separate round trip to render the settled drawer.
    var applied = await post('cart/update.js', { discount: codes.join(','), sections: ['cart-drawer'], sections_url: root('') });
    if (code && !(applied.discount_codes || []).some(function (entry) { return entry.code.toLowerCase() === code.toLowerCase() && entry.applicable; })) {
      codeCache = null;
      saveCache();
      throw new Error('Shopify rejected the bundle discount. Check discount combinations.');
    }
    if (codeCache && !skipped) {
      codeCache.prices = paidPrices(applied);
      codeCache.codes = codeStatus(applied);
    }
    saveCache();
    return applied;
  }
  async function reconcile() {
    var deadline = Date.now() + 45000;
    for (var pass = 0; pass < 12; pass++) {
      if (Date.now() > deadline) throw new Error('Cart did not settle');
      await idle();
      var version = revision, cart = await nextCart();
      if (active || version !== revision) continue;
      // New or changed lines show at once; add-ons, gift and discount follow behind them.
      if (pass === 0 && revision > 0 && adapters.render && renderedLines !== null && linesKey(cart) !== renderedLines) {
        var shown = await sectionFor(cart);
        if (active || version !== revision) continue;
        await adapters.render(wantOpen, shown);
        renderedLines = linesKey(cart);
      }
      if (adapters.prepare && await adapters.prepare(cart)) continue;
      if (cart.sections) readTagsFromHtml(cart.sections['cart-drawer']);
      await ensureTags(cart);
      if (active || version !== revision) continue;
      // A bundle discount takes ~3 s: show the new lines now, with the loader over the
      // drawer and checkout locked, then swap in the discounted cart.
      if (revision > 0 && bearWaitAhead(cart) && adapters.render) {
        discounting = true;
        feedback(null, true);
        if (linesKey(cart) !== renderedLines) {
          var early = await sectionFor(cart);
          if (active || version !== revision) continue;
          await adapters.render(wantOpen, early);
          renderedLines = linesKey(cart);
        }
        var earlyState = Object.assign({}, cart);
        delete earlyState.sections;
        renderedCart = JSON.stringify(earlyState);
        feedback(null, true);
      }
      // After a cart change, render the drawer HTML while Bear is calculating. Used only
      // when the discount step leaves the cart as it is; otherwise update.js brings it.
      var sectionRequest = revision > 0 && !cart.sections ? baseFetch(root('') + '?section_id=cart-drawer', { cache: 'no-store' })
        .then(function (res) { return res.ok ? res.text() : null; }).catch(function () { return null; }) : null;
      var before = cart;
      cart = await discount(cart);
      if (sectionRequest && cart === before && !cart.sections) {
        var html = await sectionRequest;
        if (html && version === revision) cart.sections = { 'cart-drawer': html };
      }
      if (active || version !== revision) continue;
      if (window.mhMysteryGift && await window.mhMysteryGift.reconcile(cart, post)) continue;
      if (active || version !== revision) continue;
      var gift = cart.items.find(function (item) { return item.properties && item.properties._mh_gift === 'mystery-gift'; });
      if (gift && gift.final_line_price !== 0) throw new Error('The mystery gift is not free. Check the automatic gift discount and combinations.');
      var state = Object.assign({}, cart);
      delete state.sections;
      var signature = JSON.stringify(state);
      // First pass on a fresh page: the server-rendered drawer already shows this cart.
      if (renderedCart === null) {
        var live = document.querySelector('mh-cart-drawer');
        if (live && live.getAttribute('data-cart-signature') === serverSignature(cart)) renderedCart = signature;
      }
      if (signature !== renderedCart && adapters.render) await adapters.render(wantOpen, cart);
      if (active || version !== revision) continue;
      renderedCart = signature;
      renderedLines = linesKey(cart);
      // The add-on rows exist only once the drawer has items, so default-on add-ons are
      // added right after the first render instead of on the customer's next click.
      if (adapters.prepare && await adapters.prepare(cart)) continue;
      discounting = false;
      settledCart = cart;
      settledRevision = revision;
      pendingCart = null; pendingSections = null;
      return cart;
    }
    throw new Error('Cart keeps changing; reconciliation stopped');
  }
  function refresh(openDrawer) {
    wantOpen = wantOpen || !!openDrawer;
    // Show the drawer immediately; checkout remains gated while prices settle.
    if (openDrawer) {
      var drawer = document.querySelector('mh-cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }
    if (running) return running;
    if (timer) { window.clearTimeout(timer); timer = null; }
    lastError = null;
    feedback(null, true);
    running = reconcile().catch(function (error) {
      discounting = false;
      lastError = error;
      pendingCart = null; pendingSections = null;
      var drawer = document.querySelector('mh-cart-drawer');
      if (wantOpen && drawer && typeof drawer.open === 'function') drawer.open();
      console.error('[mh-cart-sync]', error);
      throw error;
    }).finally(function () {
      running = null; wantOpen = false;
      var pending = !lastError && (active > 0 || settledRevision !== revision);
      feedback(lastError, pending);
      // A write finishing between the final render and this microtask must not
      // lose its refresh merely because it observed the previous running job.
      if (pending) schedule(false);
    });
    return running;
  }
  function schedule(openDrawer) {
    wantOpen = wantOpen || !!openDrawer;
    if (running || checkout) return;
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () { timer = null; refresh(wantOpen).catch(function () {}); }, 40);
  }
  async function checkoutCart() {
    if (checkout) return;
    checkout = true;
    try {
      var cart = await refresh(false);
      while (active || settledRevision !== revision) cart = await refresh(false);
      if (!cart.items.length || !cart.items.some(function (item) { return item.final_line_price > 0 && !(item.properties && item.properties._mh_gift); })) throw new Error('There are no paid items in this cart');
      // Discount is persisted in Shopify, not just a drawer label or cookie.
      var url = new URL(root('checkout'), window.location.origin);
      var codes = (cart.discount_codes || []).filter(function (entry) { return entry.applicable; }).map(function (entry) { return entry.code; });
      if (codes.length) url.searchParams.set('discount', codes.join(','));
      window.__mhCdNavigatingAway = true;
      window.location.assign(url.toString());
    } catch (error) { lastError = error; feedback(error, false); console.error('[mh-cart-sync:checkout]', error); }
    finally { checkout = false; }
  }
  // The drawer knows the resulting cart before the server does (+1, -1, remove): start
  // the Bear request at the click, in parallel with cart/change.js.
  function predict(change) {
    try {
      if (!settledCart) return;
      var cart = JSON.parse(JSON.stringify(settledCart));
      delete cart.sections;
      if (change(cart) === false) return;
      prefetch(cart);
    } catch (_) {}
  }
  window.mhCartSync = { predict: predict, configure: function (value) { adapters = value; }, refresh: refresh, schedule: schedule, checkout: checkoutCart, readCart: readCart, post: post, isBusy: function () { return !!running || active > 0; } };
})();
